/* eslint-disable new-cap */
/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('FormalizationProposalStatusController', formalizationProposalStatusController)

  formalizationProposalStatusController.$inject = ['$rootScope', 'ngTableParams', '$http', 'FormalizationProposalStatusService', 'NotificationService']

  function formalizationProposalStatusController ($rootScope, ngTableParams, $http, FormalizationProposalStatusService, NotificationService) {
    var vm = this

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    }

    vm.dateSelected = function (type, date) {
      if (type === 'from') {
        vm.pkadayToDate.setMinDate(date)
      }
      if (type === 'to') {
        vm.pkadayFromDate.setMaxDate(date)
      }
    }

    function validateFields () {
      var toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
      var fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
      if (toDate < fromDate) {
        NotificationService.warningHandler('', 'Data inicial Invalida')
        vm.show = false
        return false
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        vm.show = false
        NotificationService.warningHandler('', 'Periodo maximo de busca de 30 dias')
        return false
      }
      return true
    }

    vm.searchProposals = function () {
      if (validateFields()) {
        vm.contactsTable = new ngTableParams({
          page: 1,
          count: 25
        }, {
          getData: function ($defer, params) {
            vm.filters.page = params.url().page
            vm.filters.count = params.url().count
            FormalizationProposalStatusService
              .getProposals(vm.filters)
              .$promise
              .then(function (data) {
                if (data) {
                  if (data.contacts.length === 0) {
                    NotificationService.warningHandler(data, $rootScope.labels.noRecord)
                  }
                  $defer.resolve(data.contacts)
                  params.total(data.total)
                } else {
                  NotificationService.errorHandler(data, $rootScope.labels.errorReport)
                }
              }).catch(function (data) {
                NotificationService.errorHandler(data, $rootScope.labels.errorReport)
              })
          }
        })
      }
    }

    vm.downloadProposals = function () {
      if (validateFields()) {
        $http.get(apiUrl + '/formalization-proposal-status/downloadReport', { params: vm.filters })
          .then(function ({ data }) {
            if (data.warning) {
              NotificationService.warningHandler(data, data.message)
              return
            }
            const success = prepareFileForDownload(data)
            if (!success) {
              NotificationService.warningHandler(data, $rootScope.labels.noRecord)
            }
          }, function () {
            NotificationService.errorHandler('', $rootScope.labels.errorReport)
          })
      }
    }

    function prepareFileForDownload (data) {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)

      let blob = new Blob([data], { type: 'text/csv' })

      if (blob.size <= 58) {
        return false
      }

      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: 'formalization-proposal-status.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }

    vm.resubmitProposal = function (proposalNumber, contactId, companyId, historyId, proposal) {
      if (!proposal.signed_ccb) {
        NotificationService.warningHandler('', $rootScope.labels.unsignedProposal)
        return false
      }
      FormalizationProposalStatusService
        .resubmitProposal({
          'proposalNumber': proposalNumber,
          'proposal': proposal,
          'historyId': historyId
        })
        .$promise
        .then(function (data) {
          if (data.success) {
            proposal.statusSentP3 = true
            NotificationService.warningHandler(data, $rootScope.labels.docSendingAgain)
          } else {
            NotificationService.errorHandler(data, data.message)
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorDocSendingAgain)
        })
    }
  }
  // eslint-disable-next-line semi
})();
